import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DangerousIcon from '@mui/icons-material/Dangerous';

export default function Notification({ type='success', message, setNotification }) {
    useEffect(() => {
        setTimeout(() => {
            setNotification({})
        }, 3000)
    }, [])
  return (
    <div className={`w-full flex gap-5 items-center p-3 ${type == 'success' ? 'bg-main' : 'bg-[#ff4848]'} rounded-md shadow-sm`}>
        {type == 'success' ? (
            <CheckCircleIcon style={{color: '#ffffff', fontSize: 25}}>Filled</CheckCircleIcon>
        )  : <DangerousIcon style={{color: '#ffffff', fontSize: 25}}>Filled</DangerousIcon>
        }
        <p className='text-white font-bold text-[16px]'>{message}</p>
    </div>
  )
}
